import { axios } from '@pukka/auth';
import { MOKA_SERVICE_HOST } from '@pukka/common/constants';
import { storage } from '@pukka/storage';
import { getUnleashClient } from '@pukka/unleash';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ProfileModel } from '../models';

const PROFILE_URL = `${MOKA_SERVICE_HOST}/account/v2/profile`;

async function fetchProfile() {
  const resp = await axios.get<ProfileModel.Response>(PROFILE_URL);
  const profile = resp.data;

  // TODO: if pukka becomes SPA in the future, please reset the context when logged out
  if (profile.business?.id) {
    const unleashClient = await getUnleashClient();
    const context = unleashClient.getContext();

    // TODO: need to check whether we need to check isReady or not,
    // for now we keep update the context even if isReady is false
    if (
      !context.userId
      // && unleashClient?.isReady
    ) {
      await unleashClient.updateContext({ userId: profile?.business?.id?.toString() });
    }
  }

  // This is for fake login purpose, if we don't set this, the legacy will throw us
  // to login again because in legacy, they weirdly checking on this to know if user is
  // signed in or no. We should change the logic of isLoggedIn() inside legacy.
  storage.set('response:login', profile, {
    session: 'user',
  });

  return profile;
}

function useProfile(options: UseQueryOptions<ProfileModel.Response> = {}) {
  return useQuery<ProfileModel.Response>(['profile'], fetchProfile, {
    refetchOnMount: false,
    ...options,
  });
}

export { PROFILE_URL, useProfile };
